import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
  iframeRoot: {
    display: 'flex',
    height: '100%',
    [theme.breakpoints.down(theme.size.xs)]: {
      flexDirection: 'column',
    },
  },
  container: {
    width: '100%',
  },
  ul: {
    margin: 0,
    marginRight: 20,
    padding: 0,
    listStyle: 'none',
    [theme.breakpoints.down(theme.size.xs)]: {
      marginRight: 0,
      marginBottom: 30,
    },
  },
  li: {
    marginBottom: 15,
    fontSize: 17,
    color: theme.custom.darkBlue,
    cursor: 'pointer',
    '&:last-child': {
      marginBottom: 0,
    },
    '&:hover': {
      color: theme.custom.lightBlue,
    },
  },
  active: {
    color: theme.custom.lightBlue,
    cursor: 'default',
  },
}));
